import { Link, useParams } from "react-router-dom";
import { useLang } from "../i18n";
import { useSectors, useSiteImages } from "../content/useContent";
import { IconByName } from "../components/IconByName";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { FinalCTA } from "../components/FinalCTA";
import { Check, ArrowRight } from "lucide-react";
import NotFound from "./NotFound";

const SectorDetail = () => {
  const { lang, t, p } = useLang();
  const { slug } = useParams();
  const sectors = useSectors();
  const IMG = useSiteImages();
  const sec = sectors.find((s) => s.slug === slug);
  if (!sec) return <NotFound />;
  const c = sec[lang];

  return (
    <div data-testid={`sector-page-${slug}`}>
      <Seo title={c.title} description={c.short} path={`secteurs/${slug}`} />
      <PageHero eyebrow={t.nav.sectors.toUpperCase()} title={c.title} sub={c.short}
        image={IMG.cityNight} crumbs={[{ label: t.nav.sectors, to: p("secteurs") }, { label: c.title }]} />
      <section className="bg-[#F5F5F3]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12">
          <Reveal className="lg:col-span-7">
            <p className="text-base sm:text-lg text-[#101214]/75 leading-relaxed">{c.body}</p>
            <ul className="mt-8 space-y-4">
              {c.points.map((pt) => (
                <li key={pt.slice(0, 26)} className="flex items-start gap-3 text-sm sm:text-base text-[#101214]/75">
                  <Check size={18} className="text-[#FF6600] shrink-0 mt-0.5" />{pt}
                </li>
              ))}
            </ul>
            <div className="mt-10 flex flex-wrap gap-3">
              <Link to={p("demander-un-devis")} data-testid="sector-quote-cta"
                className="inline-flex items-center gap-2 bg-[#FF6600] hover:bg-[#FF9900] text-[#08090A] font-black rounded-full px-7 py-3.5 text-sm transition-colors">
                {t.nav.quote} <ArrowRight size={16} />
              </Link>
              <Link to={p("verifier-la-couverture")} data-testid="sector-coverage-cta"
                className="inline-flex items-center gap-2 border border-[#101214]/20 hover:border-[#FF6600] text-[#101214] font-bold rounded-full px-7 py-3.5 text-sm transition-colors">
                {t.nav.coverage}
              </Link>
            </div>
          </Reveal>
          <aside className="lg:col-span-5">
            <Reveal className="bg-white rounded-2xl border border-[#101214]/10 p-7">
              <h3 className="font-bold text-[#101214]">{lang === "fr" ? "Autres secteurs" : "Other sectors"}</h3>
              <ul className="mt-4 space-y-3">
                {sectors.filter((s) => s.slug !== slug).map((s) => (
                  <li key={s.slug}>
                    <Link to={p(`secteurs/${s.slug}`)} className="flex items-center gap-3 text-sm font-bold text-[#101214]/70 hover:text-[#FF6600] transition-colors">
                      <IconByName name={s.icon} size={17} className="text-[#FF6600]" />{s[lang].title}
                    </Link>
                  </li>
                ))}
              </ul>
            </Reveal>
          </aside>
        </div>
      </section>
      <FinalCTA />
    </div>
  );
};

export default SectorDetail;
